import { render, staticRenderFns } from "./myConsultation.vue?vue&type=template&id=008d9d32&scoped=true&"
import script from "./myConsultation.vue?vue&type=script&lang=js&"
export * from "./myConsultation.vue?vue&type=script&lang=js&"
import style0 from "./myConsultation.vue?vue&type=style&index=0&id=008d9d32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008d9d32",
  null
  
)

export default component.exports